import { db } from "../firebase";
import { collection, addDoc, getDocs, doc, updateDoc, query, where, deleteDoc, writeBatch } from "firebase/firestore";

const getPayments = async () => {
  const querySnapshot = await getDocs(collection(db, "payments"));
  const payments = [];
  querySnapshot.forEach((doc) => {
    payments.push({ _id: doc.id, ...doc.data() });
  });
  return payments;
};

const fetchMyPayments = async (userId) => {
  const q = query(collection(db, "payments"), where("userId", "==", userId));
  const querySnapshot = await getDocs(q);
  const payments = [];
  querySnapshot.forEach((doc) => {
    payments.push({ _id: doc.id, ...doc.data() });
  });
  return payments;
};

const createPayment = async (paymentData) => {
  const docRef = await addDoc(collection(db, "payments"), {
    ...paymentData,
    createdAt: new Date().toISOString()
  });
  return { _id: docRef.id, ...paymentData };
};

const updatePaymentStatus = async (paymentId, status) => {
  const paymentRef = doc(db, "payments", paymentId);
  await updateDoc(paymentRef, { status });
  return { message: "Payment status updated" };
};

const deleteUserPayments = async (userId) => {
  const q = query(collection(db, "payments"), where("userId", "==", userId));
  const querySnapshot = await getDocs(q);
  const batch = writeBatch(db);

  querySnapshot.forEach((doc) => {
    batch.delete(doc.ref);
  });

  await batch.commit();
  return { message: "User payments deleted" };
};

const paymentService = {
  getPayments,
  fetchMyPayments,
  createPayment,
  updatePaymentStatus,
  deleteUserPayments,
};

export default paymentService;
